import React from 'react';
import { useTheme } from '../../../contexts/ThemeContext';
import './DriverRankingTable.css';

const DriverRankingTable = ({ data = [] }) => {
  const { isDark } = useTheme();
  const list = Array.isArray(data) ? data : [];
  
  // Encontra o score máximo para calcular percentuais
  const maxScore = Math.max(...list.map(item => item.score || 0), 0);
  
  // Cores alternadas para as linhas baseadas no tema
  const getRowColor = (index) => {
    if (isDark) {
      return index % 2 === 0 ? '#2d3748' : '#4a5568';
    }
    return index % 2 === 0 ? '#f8f9fa' : '#ffffff';
  };

  // Cores para as barras de progresso
  const getBarColor = (index) => {
    const colors = ['#28a745', '#007bff', '#ffc107', '#dc3545', '#6f42c1'];
    return colors[index % colors.length];
  };

  return (
    <div className={`driver-ranking-container ${isDark ? 'dark-theme' : 'light-theme'}`} style={{ margin: 0, padding: 0 }}>
      <div className="driver-ranking-header">
        <div className="driver-ranking-header-cell score-header">Score</div>
        <div className="driver-ranking-header-cell plate-header">Placa</div>
      </div>
      
      <div className="driver-ranking-body">
        {list.map((item, index) => {
          const percentage = maxScore > 0 ? (item.score / maxScore) * 100 : 0;
          
          return (
            <div 
              key={index} 
              className="driver-ranking-row"
              style={{ backgroundColor: getRowColor(index) }}
            >
              <div className="driver-ranking-cell score-cell">
                <div className="score-value">{item.score?.toFixed(2) || '0.00'}</div>
                <div className="progress-bar-container">
                  <div 
                    className="progress-bar"
                    style={{
                      width: `${percentage}%`,
                      backgroundColor: getBarColor(index)
                    }}
                  />
                </div>
              </div>
              <div className="driver-ranking-cell plate-cell">
                {item.identity || item.plate || 'N/A'}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default DriverRankingTable;
